import { render, staticRenderFns } from "./detailServer.vue?vue&type=template&id=51112f00&"
import script from "./detailServer.vue?vue&type=script&lang=js&"
export * from "./detailServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports